import {FilterAttribute} from "./filter-attribute";

export class FilterAttributeGroup {

    name: string;
    label: string;
    //joinObjectTypeAlias: string;
    //joinObjectTypeId: number;
    //dataType: number;
    //icon: string | undefined;
    filterAttributes: FilterAttribute[];

    /**
     * Create filter attribute group.
     * @param name
     * @param label
     * @param filterAttributes
     */
    public static create(name: string, label: string, filterAttributes: FilterAttribute[]): FilterAttributeGroup {
        const filterAttributeGroup = new FilterAttributeGroup();
        filterAttributeGroup.name = name;
        filterAttributeGroup.label = label;
        filterAttributeGroup.filterAttributes = filterAttributes;
        return filterAttributeGroup;
    }

}